import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 0;
  min-height: 52px;
`;

const PageBtn = styled.button`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 13px;
  color: ${({ $active, theme }) => ($active ? '#fff' : theme.colors.textSecondary)};
  background: ${({ $active, theme }) => ($active ? theme.colors.primary : 'transparent')};
  transition: all 0.15s;

  &:hover:not(:disabled) {
    background: ${({ $active, theme }) => ($active ? theme.colors.primary : theme.colors.bg)};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

const Pagination = ({ current = 1, total = 1, onChange }) => {
  const pages = [];
  for (let i = 1; i <= total; i++) pages.push(i);

  return (
    <Wrapper>
      <PageBtn disabled={current <= 1} onClick={() => onChange(current - 1)}>이전</PageBtn>
      {pages.map((p) => (
        <PageBtn key={p} $active={p === current} onClick={() => onChange(p)}>{p}</PageBtn>
      ))}
      <PageBtn disabled={current >= total} onClick={() => onChange(current + 1)}>다음</PageBtn>
    </Wrapper>
  );
};

export default Pagination;
